export const getExportTypes = () => `/homeowner/cases/exports/all-available`;